import {Archetype} from "features/apartmentViewer/types";

export class FurnishingModel {
    private _id: string;
    private _description: string;
    private _title: string;

    constructor(
        furnishing: Archetype
    ) {
        this._id = furnishing.archetypeID;
        this._title = furnishing.title;
        this._description = furnishing.description;
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }
    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }
    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }
}
